import { GTM_KEY } from '@/env'
import { isMockHarness } from '@/utils/mockHarness'
import { useEffect } from 'react'
import TagManager from 'react-gtm-module'

export const GoogleTagManagerProvider = () => {
  useEffect(() => {
    // Dev mock harness: its fake wallet events must not reach a real container.
    if (isMockHarness()) return

    const tagManagerArgs = {
      gtmId: GTM_KEY || ''
    }

    if (tagManagerArgs.gtmId) {
      TagManager.initialize(tagManagerArgs)
    }
  }, [])

  return <></>
}
